import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { EditPage } from '../edit_page/EditPage';
import ProjectCreateForm from '../project_create_form/ProjectCreateForm';

class ProjectNewPage extends React.Component<any, any> {
	render() {
		const { history } = this.props;

		return [
			<EditPage
				title="Create New Project"
				formComponentProps={{
					formData: {},
					isApprovalForm: false,
					onSuccess: (rec) => history.goBack(),
				}}
				fetching={false}
				FormComponent={ProjectCreateForm}
			/>,
		];
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		history: ownProps.history,
		match: ownProps.match,
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default withRouter<any, any>(connect(mapStateToProps, mapDispatchToProps)(ProjectNewPage));
